import { useState } from 'react';
import { isServer } from '~/lib/helpers/isServer';

export const useIsDebug = () => {
    const [isDebug] = useState(!isServer && window.location.search.includes('debug=true'));

    return isDebug;
};
